import type { ServiceUsagesGroupReorganizeInput } from '../../types/service-usages-group-reorganize-input.type';
import type { ReorderDrawerGroupView } from '../types';

export const toReorderDrawerInput = (
  groups: readonly ReorderDrawerGroupView[],
): readonly ServiceUsagesGroupReorganizeInput[] =>
  groups.map((group) => ({
    groupId: group.groupId,
    serviceUsageIds: group.serviceUsages.map(
      (serviceUsage) => serviceUsage._id,
    ),
  }));

export const buildLabelMaps = (groups: readonly ReorderDrawerGroupView[]) => ({
  groupLabelById: new Map(
    groups.map((group) => [group.groupId.toString(), group.label]),
  ),
  usageLabelById: new Map(
    groups.flatMap((group) =>
      group.serviceUsages.map(
        (usage) => [usage._id.toString(), usage.label] as const,
      ),
    ),
  ),
});
